module.exports = __webpack_public_path__ + "static/img/44.06392422.png";